(function () {
    angular.module('Directives')
        .directive('bbaTextInput', bbaTextInput);

    function bbaTextInput($compile, $filter, $timeout, $parse) {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/bbaTextInput.html',
            require: ['^form','ngModel'],
            replace: true,
            scope: {
                inputType: '@',
                ngDisabled: '=?',
                ngModel: '=',
                hasError: '=',
                maxlength:'=?',
                tooltip: '=?',
                hideInfoTooltip: '=?',
                tooltipInfo: '@'
            },
            controller: bbaTextInputLink,
            compile: bbaTextInputCompile
        };
        function bbaTextInputCompile(tElement) {
            return {
                post: function postLink($scope, $element, $attrs, ngModels) {
                    const language = `placeholder.textInput${$scope.inputType ? $scope.inputType.toUpperCase : ''}`
                                      .replace(/(\r\n|\n|\r)/gm, "");
                    const translated = $filter('translate')(language)
                                       .replace(/(\r\n|\n|\r)/gm, "");

                    $scope.getTooltip = getTooltip;
                    $scope.$watch(()=>{
                        ngModels[1].$setValidity("isValid", !$scope.hasError);
                        return (ngModels[1].$invalid && ngModels[1].$touched) || (ngModels[1].$invalid && ngModels[0].$submitted)
                    }, newVal=>{
                        let elementId = $element.attr('id');
                        $scope.elemLabel = $('label[for="' + elementId + '"]');
                        $scope.elemParent = angular.element($element).parent();
                        $scope.placeholder = translated === language ?
                                             $scope.elemLabel.text().replace(/\s\s+/g, ' ').replace(':', '') : translated;

                        if(newVal){
                            $scope.elemParent.addClass('has-warning');
                        }else{
                            $scope.elemParent.removeClass('has-warning');
                        }
                        $scope.isInvalid = newVal;
                    });

                    function getTooltip () {
                        if($scope.isInvalid){
                            return getErrorTooltip(ngModels[1].$error);
                        }
                        return setGenericTooltip();

                    }
                    function getErrorTooltip(errMsg) {
                        const warningTooltip = 'messages.warning.tooltip.' + ($scope.inputType || '').toUpperCase();
                        let name = $scope.elemLabel.text().replace(/\s\s+/g, ' ').replace(':', '').replace('*', '');
                        
                        if(errMsg.isUnique && !errMsg.required) {
                            return `${name} is already taken.`;
                        }
                        else if(errMsg.required) {
                            return `${name ? name : $filter('bbaCapitalize')($scope.inputType.split('_').join(' '))} is required`;
                        }
                        else if($filter('translate')(warningTooltip) !== warningTooltip){
                            return $filter('translate')(warningTooltip);
                        }
                    }
                    function setGenericTooltip() {
                        const infoTooltip = 'messages.info.tooltip.' + ($scope.tooltipInfo || $scope.inputType || '').toUpperCase();
                        if($scope.tooltip){
                            return $scope.tooltip;
                        }
                        if($filter('translate')(infoTooltip) !== infoTooltip){
                            return $filter('translate')(infoTooltip);
                        }
                        if(!$scope.hideInfoTooltip) {
                            return $scope.elemLabel.text().replace(/\s\s+/g, ' ').replace(':', '').replace('*', '');
                        }
                    }
                }
            };

        }
        function bbaTextInputLink($scope, $element, $attrs) {
        }
    };
})();



// WEBPACK FOOTER //
// ./js/directives/bbaTextInput.js